//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "TheCookie",

  data() {
    return {
      showedCookie: false
    }
  },

  mounted() {
    const confirmedCookie = this.getCookie('my_cookie_consent');
    if (!confirmedCookie) {
      this.showedCookie = true
    }
  },

  methods: {
    getCookie(name) {
      const cookies = document.cookie.split('; ');
      for (const cookie of cookies) {
        const [key, value] = cookie.split('=');
        if (key === name) return value;
      }
    },
    confirmCookie() {
      document.cookie = "my_cookie_consent=true; max-age=31536000";
      this.showedCookie = false
    }
  }
}
